var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exchange" },
    [
      _c("div", { staticClass: "bg_color" }, [
        _c("div", { staticClass: "exchangeName" }, [_vm._v("当前积分")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "exchangeNum", on: { click: _vm.toDetails } },
          [
            _c("img", { staticClass: "imgleft", attrs: { src: _vm.logoUrl } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.allIntegral))]),
            _vm._v(" "),
            _c("span", { staticClass: "toDetail" }, [_vm._v(">")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "useIntegral" }, [
        _vm._v("可用积分" + _vm._s(_vm.integral))
      ]),
      _vm._v(" "),
      _vm._l(_vm.rules, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "exchangeitem" },
          [
            _c("div", { staticClass: "itemleft" }, [
              _c("p", { staticClass: "left_top" }, [_vm._v("积分抵现")]),
              _vm._v(" "),
              _c("p", { staticClass: "left_bot" }, [
                _c("span", [_vm._v("￥")]),
                _vm._v(" "),
                _c("span", { staticClass: "bot_big" }, [
                  _vm._v(_vm._s(item.amt))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "itemcenter" }, [
              _c("p", { staticClass: "center_top" }, [
                _vm._v(_vm._s(item.amt) + "元现金")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "center_bot" }, [
                _vm._v(_vm._s(item.name))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "itemright",
                class:
                  Number(item.integral) > Number(_vm.integral)
                    ? "disabled"
                    : "",
                on: {
                  click: function($event) {
                    return _vm.hanleExchange(item)
                  }
                }
              },
              [_vm._v("\n      兑换\n    ")]
            ),
            _vm._v(" "),
            _vm.tips ? _c("Promptbox", { attrs: { message: 16 } }) : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4ee366a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4ee366a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/integralExchange/index.vue
// module id = null
// module chunks = 